import React, { CSSProperties, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../../store';
import { fetchQuickSurveylist, fetchSingleApp } from '../../../store/actions';
import AuthHandler from '../../../helper/AuthHandler';
import TableIcon from '../../../assets/images/icons/app-media-placeholder.svg';
import { PageHeaderStatic } from "../components/PageHeaderStatic";
import { confirmAlert } from "react-confirm-alert";
import { Tooltip } from "antd";
import { EyeOutlined, DeleteOutlined } from "@ant-design/icons";
import Moment from 'moment';

const override: CSSProperties = {
    display: "block",
    margin: "0 auto"
};

const QuickSurveyList = ({ auth }: any) => {

    const { wid } = useParams();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const { userDetails } = useSelector(({ user }: any) => user);
    const { success, loading, error, quickSurveyList } = useSelector(({ quicksurvey }: any) => quicksurvey);

    useEffect(() => {
        const tenantGUID = (userDetails && userDetails.OwnedEnterprises[0]) ? userDetails.OwnedEnterprises[0].groupId : "";
        dispatch(fetchSingleApp(wid!, tenantGUID));
    }, [wid, userDetails]);

    useEffect(() => {
        const tenantGUID = (userDetails && userDetails.OwnedEnterprises[0]) ? userDetails.OwnedEnterprises[0].groupId : "";
        dispatch(fetchQuickSurveylist(tenantGUID, wid!));
    }, [wid, userDetails]);

    const onViewConfig = (surveyId: string) => {
        navigate(`/survey/${wid}/survey-update/${surveyId}`);
    }

    const onDetailConfig = (surveyId: string) => {
        navigate(`/survey/${wid}/surveylogs/${surveyId}`);
    }

    const renderConfigList = () => {
        if (success && quickSurveyList) {
            if (quickSurveyList.length > 0) {
                return (
                    <div className="section__wrapper">
                        <div className="card panel content-holder-panels">
                            <div className="panel-header">
                                <div className="panel-header-content__wrapper">
                                    <h4 className="panel-header-title">List of Configs</h4>
                                </div>
                            </div>
                            <div className="panel-table-listing__wrapper">
                                <div className="table-parent__wrapper">
                                    <table className="table table-default">
                                        <tbody>
                                            <tr className="table-header">
                                                <th className="txt-left">#</th>
                                                <th className="txt-left">Survey Ref</th>
                                                <th className="txt-left">Owner number</th>
                                                <th className="txt-left">Survey Title</th>
                                                <th className="txt-left">Start Time</th>
                                                <th className="txt-left">End Time</th>
                                                <th className="txt-left">Status</th>
                                                <th className="txt-left">Created By</th>
                                                <th className="txt-left">Created Date</th>
                                                <th className="txt-left">Remarks</th>
                                                <th className="txt-left">Details</th>
                                                <th className="txt-left">Status</th>
                                            </tr>
                                            {quickSurveyList.map((value: any, index: number) => {
                                                return (
                                                    <tr className="table-row ">
                                                        <td className="txt-left">{index + 1}</td>
                                                        <td className="txt-left">{value.uuid}</td>
                                                        <td className="txt-left">{value.ownerNumber}</td>
                                                        <td className="txt-left">{value.surveyTitle}</td>
                                                        <td className="txt-left">{Moment(value.startTime).format('YYYY-MM-DD HH:mm')}</td>
                                                        <td className="txt-left">{Moment(value.endTime).format('YYYY-MM-DD HH:mm')}</td>
                                                        <td className="txt-left">{value.status}</td>
                                                        <td className="txt-left">{value.createdBy}</td>
                                                        <td className="txt-left">{Moment(value.createdAt).format('YYYY-MM-DD HH:mm')}</td>
                                                        <td className="txt-left">{value.remarks === null ? '-' : value.remarks === '' ? '-' : value.remarks}</td>
                                                        <td className="txt-left" style={{ textAlign: 'center' }}>
                                                            <Tooltip title="View">
                                                                <EyeOutlined onClick={() => onViewConfig(value.uuid)} />
                                                            </Tooltip>
                                                        </td>
                                                        <td className="txt-left" style={{ textAlign: 'center' }}>
                                                            <Tooltip title="View">
                                                                <EyeOutlined onClick={() => onDetailConfig(value.uuid)} />
                                                            </Tooltip>
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            } else {
                let path = window.location.pathname.split('/');
                return (
                    <div className="section__wrapper">
                        <div className="empty-state-new-action__wrapper">
                            <div className="new-action-content__wrapper">
                                <h4 className="sub">No Records available</h4>
                                <h4 className="title">Create new request</h4>
                                <button className="btn btn-primary" onClick={() => navigate(path[0] + '/' + path[1] + '/' + path[2] + '/survey-create')}>New request</button>
                            </div>
                        </div>
                    </div>
                )
            }
        } else if (loading) {
            return (
                <div className="section__wrapper">
                    <div className="empty-state-new-action__wrapper">
                        <section className="content__wrapper">
                            <div className="primaryBrandLoaderBg">
                                <div className="primaryBrandLoader">
                                    <img src={require('../../../assets/images/loader-bg-primary.svg').default} alt="" srcSet="" />
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            )
        } else if (error) {
            return (
                <div className="section__wrapper">
                    <div className="empty-state-new-action__wrapper">
                        <div className="new-action-content__wrapper">
                            <h4 className="sub">Oops, something went wrong!</h4>
                        </div>
                    </div>
                </div>
            )
        }
    }

    if (AuthHandler.isAuthorized(auth, 'sentiment-face-2-list') && userDetails !== null) {
        let path = window.location.pathname.split('/');
        return (
            <React.Fragment>
                <div className="main-content main-spacer-x-y">
                    <PageHeaderStatic
                        listShow={Array.isArray(quickSurveyList) && quickSurveyList.length > 0}
                        page={'list'}
                        newButtonLink={path[0] + '/' + path[1] + '/' + path[2] + '/survey-create'}
                    />
                    {renderConfigList()}
                </div>

            </React.Fragment>
        );
    } else return (<React.Fragment></React.Fragment>);

}

export default QuickSurveyList;